import React from 'react';
import { Crosshair } from '@phosphor-icons/react';

/* GPS status pill.
   - null accuracy → gray (unavailable)
   - <15m → emerald (good)
   - <35m → amber (fair)
   - else → red (poor) */
export default function GpsPill({ accuracy, className = '' }) {
  let color = 'text-zinc-400 border-zinc-500/40 bg-zinc-500/10';
  let label = 'GPS OFF';
  let dot = 'bg-zinc-500';
  if (accuracy != null && !isNaN(accuracy)) {
    if (accuracy < 15) { color = 'text-emerald-400 border-emerald-500/30 bg-emerald-500/10'; label = 'GPS STRONG'; dot = 'bg-emerald-400 pulse-dot'; }
    else if (accuracy < 35) { color = 'text-amber-300 border-amber-500/30 bg-amber-500/10'; label = 'GPS FAIR'; dot = 'bg-amber-400'; }
    else { color = 'text-rose-400 border-rose-500/30 bg-rose-500/10'; label = 'GPS POOR'; dot = 'bg-rose-400'; }
  }
  return (
    <div
      data-testid="gps-status"
      className={`inline-flex items-center gap-2 px-2.5 py-1 rounded-full text-[11px] font-semibold uppercase tracking-wider border ${color} ${className}`}
    >
      <span className={`w-1.5 h-1.5 rounded-full ${dot}`} />
      <Crosshair size={12} weight="bold" />
      <span>{label}</span>
      {accuracy != null && !isNaN(accuracy) && (
        <span className="font-mono-stat text-[10px] opacity-80">±{Math.round(accuracy)}m</span>
      )}
    </div>
  );
}
